import React from 'react';
import { guideLog } from '../../dataServices/guideLog';
import { PlainText } from '../plainText/plainText';
import { CustomDialog } from '../../common/components/modalDialog';
import { closeExpireDialog } from '../../dataServices/updateGuideStatus';

import './expireConfirm.scss';
/**
 * 团队版到期弹窗提示
 */
export const ExpireConfirm = (props: {onCancel: VoidFunction}) => {
    const goUpgrade = () => {
        props.onCancel();
        const doJump = () => {
            location.href = location.origin + '/plan/pricing';
        };
        guideLog({page_type: 2, action_type: 3}).then(doJump, doJump);
    };

    const onCancel = () => {
        guideLog({page_type: 2, action_type: 2});
        props.onCancel();
    };

    const render = () => {
        return (
            <div>
                <div className="illustration" />
                <div className="main-title">
                    <PlainText>您的团队版试用已到期</PlainText>
                </div>
                <div className="sub-title">
                    <PlainText>您可以继续使用团队版，或者降级为基本版。</PlainText>
                </div>
                <div className="desc">
                    <PlainText>团队版为您提供安全保密的内部学习平台，让学员爱上学习、学以致用。</PlainText>
                </div>
                <div className="operas">
                    <button className="btn btn-striking" onClick={onCancel}>
                        <PlainText>降级为基本版</PlainText>
                    </button>
                    <button className="btn btn-warning" onClick={goUpgrade}>
                        <PlainText>继续团队版</PlainText>
                    </button>
                </div>
            </div>
        );
    };

    return render();
};

export const showExpireDialog = () => {
    guideLog({page_type: 2, action_type: 1});
    var dailog = CustomDialog({
        className: 'expire-confirm-dialog',
        canClose: false,
        width: '5.9rem',
        childProps: {
            onCancel() {
                closeExpireDialog();
                dailog.destroy();
            },
        },
        contentComponent: ExpireConfirm,
    });
};
